module.exports = __webpack_public_path__ + "img/ic_services_wifi.c3fd959b.svg";